export default {
    checkLastVisited(context) {
        const currentTime = Math.floor(Date.now() / 1000);
        const lastVisited = Number(context.state.last_visited);

        const timeDifferenceInMinutes = (currentTime - lastVisited) /  60;
        if(lastVisited === null){
            return;
        }
        const mins = 2 //elapsed minutes
        if (timeDifferenceInMinutes > mins) {
            window.open('https://www.heybuddy.club/?ref=g05c4n', "_self") // Redirect the user
        }
      }
}
